/**
 * Deferred images (hover-swap product images).
 *
 * `snippets/responsive-image.liquid` with `defer: true` emits a 1px
 * placeholder plus data-src / data-srcset. Nothing is fetched until the
 * shopper first hovers or focuses the nearest `[data-defer-images]` ancestor
 * (a product card), at which point every deferred image inside it is
 * upgraded. Touch devices never hover, so they never pay for these bytes.
 *
 * `lazy_js: true` emits the same markup with class `is-lazy-js`; those are
 * upgraded by an IntersectionObserver ~300px before they enter the viewport.
 * Unlike native loading="lazy" (which fetches everything within 1250-2500px,
 * i.e. every carousel card on a mobile homepage), horizontally off-screen
 * cards are only fetched when the carousel is scrolled to them.
 */
(function () {
  'use strict';

  function upgrade(img) {
    if (!img.dataset.src) return;
    if (img.dataset.sizes) img.sizes = img.dataset.sizes;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
    delete img.dataset.sizes;
    img.classList.remove('is-deferred');
    img.classList.remove('is-lazy-js');
  }

  var io = null;
  function observe(scope) {
    var imgs = (scope || document).querySelectorAll('img.is-lazy-js');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(imgs, upgrade);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          upgrade(entry.target);
        });
      }, { rootMargin: '300px' });
    }
    Array.prototype.forEach.call(imgs, function (img) { io.observe(img); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  function onEnter(e) {
    var host = e.target && e.target.closest ? e.target.closest('[data-defer-images]') : null;
    if (!host || host.hasAttribute('data-defer-images-done')) return;
    host.setAttribute('data-defer-images-done', '');
    Array.prototype.forEach.call(host.querySelectorAll('img.is-deferred'), upgrade);
  }

  // mouseover bubbles (mouseenter does not); focusin covers keyboard users.
  document.addEventListener('mouseover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter, { passive: true });
})();
